(function(){
  var root = document.querySelector('[data-rp-root]');
  if (!root) return;
  var WORKER_URL = root.getAttribute('data-worker-url') || '';

  if (!WORKER_URL) {
    root.innerHTML = '<p class="rp-alert">The returns portal is not yet configured. Please add the API endpoint URL in theme settings for this section.</p>';
    return;
  }
  WORKER_URL = WORKER_URL.replace(/\/$/, '');

  var state = {
    step: 'lookup',
    order: null,
    email: '',
    selections: {},
    answers: { tag: null, packaging: null, used: null },
    submitting: false,
    result: null,
    error: null
  };

  function escapeHtml(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, function(c){
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
    });
  }

  function fmtMoney(amount, currency) {
    var n = parseFloat(amount);
    if (isNaN(n)) return amount;
    var symbol = currency === 'GBP' ? '£' : currency === 'USD' ? '$' : currency === 'EUR' ? '€' : '';
    return symbol + n.toFixed(2);
  }

  function render() {
    if (state.step === 'lookup') return renderLookup();
    if (state.step === 'order') return renderOrder();
    if (state.step === 'questions') return renderQuestions();
    if (state.step === 'result') return renderResult();
  }

  function renderLookup() {
    root.innerHTML = ''
      + '<div class="rp-card">'
      + '<h2 class="rp-h2">Find your order</h2>'
      + '<p class="rp-p">Enter your order number and the email address used at checkout. Returns and exchanges must be requested within 14 days.</p>'
      + (state.error ? '<p class="rp-alert">' + escapeHtml(state.error) + '</p>' : '')
      + '<label class="rp-label">Order number</label>'
      + '<input type="text" class="rp-input" id="rp-order-number" placeholder="e.g. 1234" />'
      + '<label class="rp-label">Email address</label>'
      + '<input type="email" class="rp-input" id="rp-email" placeholder="you@example.com" />'
      + '<button type="button" class="rp-btn" id="rp-lookup-btn">Find my order</button>'
      + '</div>';
    document.getElementById('rp-lookup-btn').addEventListener('click', function(){
      var num = document.getElementById('rp-order-number').value.trim();
      var email = document.getElementById('rp-email').value.trim();
      if (!num || !email) { state.error = 'Please enter both your order number and email address.'; return render(); }
      var btn = document.getElementById('rp-lookup-btn');
      btn.disabled = true; btn.textContent = 'Searching...'; state.error = null;
      fetch(WORKER_URL + '/api/lookup', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ orderNumber: num, email: email }) })
        .then(function(r){ return r.json(); }).then(function(data){
          if (!data.ok) { state.error = "We couldn't find an order matching those details. Please double-check your order number and email address."; return render(); }
          state.order = data.order; state.email = email; state.selections = {};
          data.order.items.forEach(function(item){ state.selections[item.fulfillmentLineItemId] = { checked: false, action: 'exchange', exchangeVariant: null, item: item }; });
          state.step = 'order'; render();
        }).catch(function(){ state.error = 'Something went wrong. Please try again.'; render(); });
    });
  }

  function renderOrder() {
    var order = state.order;
    if (!order.withinWindow) {
      root.innerHTML = '<div class="rp-card"><h2 class="rp-h2">' + escapeHtml(order.name) + '</h2><p class="rp-alert">This order is outside our 14-day return window, so it is not eligible for a return or exchange online. Please get in touch with us if you have a special circumstance.</p><button type="button" class="rp-btn rp-btn-secondary" id="rp-back">Back</button></div>';
      document.getElementById('rp-back').addEventListener('click', function(){ state.step = 'lookup'; render(); });
      return;
    }
    var html = '<div class="rp-card">';
    html += '<h2 class="rp-h2">' + escapeHtml(order.name) + '</h2>';
    html += '<p class="rp-p">Select the item(s) you would like to return or exchange. Exchanges are processed faster and help you get your new size or item sooner.</p>';
    order.items.forEach(function(item){
      var sel = state.selections[item.fulfillmentLineItemId];
      html += '<div class="rp-item"><div class="rp-item-row">';
      html += '<input type="checkbox" class="rp-checkbox" data-fli="' + item.fulfillmentLineItemId + '" ' + (sel.checked ? 'checked' : '') + ' />';
      if (item.image) html += '<img class="rp-item-img" src="' + escapeHtml(item.image) + '" alt="" />';
      html += '<div class="rp-item-info"><div class="rp-item-title">' + escapeHtml(item.title) + '</div>';
      if (item.variantTitle) html += '<div class="rp-item-variant">' + escapeHtml(item.variantTitle) + '</div>';
      html += '<div class="rp-item-price">' + fmtMoney(item.price, order.currency) + (item.quantity > 1 ? ' &times; ' + item.quantity : '') + '</div>';
      html += '</div></div>';
      if (sel.checked) {
        html += '<div class="rp-item-options"><div class="rp-radio-group">';
        html += '<label class="rp-radio' + (sel.action === 'exchange' ? ' rp-radio-active' : '') + '"><input type="radio" name="action-' + item.fulfillmentLineItemId + '" value="exchange" ' + (sel.action === 'exchange' ? 'checked' : '') + ' /> Exchange <span class="rp-badge">Recommended</span></label>';
        html += '<label class="rp-radio' + (sel.action === 'return' ? ' rp-radio-active' : '') + '"><input type="radio" name="action-' + item.fulfillmentLineItemId + '" value="return" ' + (sel.action === 'return' ? 'checked' : '') + ' /> Return</label></div>';
        if (sel.action === 'exchange') {
          html += '<div class="rp-exchange-picker" data-fli="' + item.fulfillmentLineItemId + '">';
          if (sel.exchangeVariant) {
            html += '<div class="rp-exchange-selected">';
            if (sel.exchangeVariant.image) html += '<img class="rp-item-img" src="' + escapeHtml(sel.exchangeVariant.image) + '" alt="" />';
            html += '<div class="rp-item-info"><div class="rp-item-title">' + escapeHtml(sel.exchangeVariant.productTitle) + '</div><div class="rp-item-variant">' + escapeHtml(sel.exchangeVariant.title) + '</div><div class="rp-item-price">' + fmtMoney(sel.exchangeVariant.price, order.currency) + '</div></div>';
            html += '<button type="button" class="rp-link rp-change-exchange">Change</button></div>';
          } else {
            html += '<label class="rp-label">Search for the item you would like instead</label>';
            html += '<input type="text" class="rp-input rp-exchange-search" placeholder="e.g. Black Kurta, size XL" /><div class="rp-exchange-results"></div>';
          }
          html += '</div>';
        }
        html += '</div>';
      }
      html += '</div>';
    });
    var anySelected = Object.keys(state.selections).some(function(k){ return state.selections[k].checked; });
    var ready = anySelected && Object.keys(state.selections).every(function(k){ var s = state.selections[k]; if (!s.checked) return true; if (s.action === 'exchange') return !!s.exchangeVariant; return true; });
    html += '<button type="button" class="rp-btn" id="rp-continue" ' + (ready ? '' : 'disabled') + '>Continue</button>';
    html += '<button type="button" class="rp-btn rp-btn-secondary" id="rp-back">Back</button></div>';
    root.innerHTML = html;
    bindOrderEvents();
  }

  function bindOrderEvents() {
    Array.prototype.forEach.call(root.querySelectorAll('.rp-checkbox'), function(cb){ cb.addEventListener('change', function(){ state.selections[this.getAttribute('data-fli')].checked = this.checked; renderOrder(); }); });
    Array.prototype.forEach.call(root.querySelectorAll('input[type=radio]'), function(rb){ rb.addEventListener('change', function(){ var fli = this.name.replace('action-', ''); state.selections[fli].action = this.value; if (this.value === 'return') state.selections[fli].exchangeVariant = null; renderOrder(); }); });
    var backBtn = document.getElementById('rp-back'); if (backBtn) backBtn.addEventListener('click', function(){ state.step = 'lookup'; state.order = null; render(); });
    var contBtn = document.getElementById('rp-continue'); if (contBtn) contBtn.addEventListener('click', function(){ state.step = 'questions'; render(); });
    Array.prototype.forEach.call(root.querySelectorAll('.rp-change-exchange'), function(btn){ btn.addEventListener('click', function(){ var fli = this.closest('.rp-exchange-picker').getAttribute('data-fli'); state.selections[fli].exchangeVariant = null; renderOrder(); }); });
    Array.prototype.forEach.call(root.querySelectorAll('.rp-exchange-search'), function(input){
      var fli = input.closest('.rp-exchange-picker').getAttribute('data-fli');
      var resultsBox = input.parentNode.querySelector('.rp-exchange-results');
      var timer = null;
      input.addEventListener('input', function(){ var q = this.value.trim(); clearTimeout(timer); if (q.length < 2) { resultsBox.innerHTML = ''; return; } timer = setTimeout(function(){ searchProducts(q, resultsBox, fli); }, 400); });
    });
  }

  function searchProducts(q, resultsBox, fli) {
    resultsBox.innerHTML = '<div class="rp-searching">Searching...</div>';
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide')
      .then(function(r){ return r.json(); }).then(function(data){
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) { resultsBox.innerHTML = '<div class="rp-searching">No products found.</div>'; return; }
        var html = '';
        products.forEach(function(p){
          html += '<div class="rp-result" data-handle="' + escapeHtml(p.handle) + '">';
          if (p.image) html += '<img class="rp-item-img" src="' + escapeHtml(p.image) + '" alt="" />';
          html += '<div class="rp-item-info"><div class="rp-item-title">' + escapeHtml(p.title) + '</div><div class="rp-item-price">' + p.price + '</div></div></div>';
        });
        resultsBox.innerHTML = html;
        Array.prototype.forEach.call(resultsBox.querySelectorAll('.rp-result'), function(el){ el.addEventListener('click', function(){ loadProductVariants(this.getAttribute('data-handle'), resultsBox, fli); }); });
      }).catch(function(){ resultsBox.innerHTML = '<div class="rp-searching">Search failed. Please try again.</div>'; });
  }

  function loadProductVariants(handle, resultsBox, fli) {
    resultsBox.innerHTML = '<div class="rp-searching">Loading...</div>';
    fetch('/products/' + handle + '.js').then(function(r){ return r.json(); }).then(function(product){
      var variants = product.variants.filter(function(v){ return v.available; });
      if (!variants.length) { resultsBox.innerHTML = '<div class="rp-searching">That product is currently sold out.</div>'; return; }
      if (variants.length === 1) { selectExchangeVariant(fli, product, variants[0]); return; }
      var html = '<label class="rp-label">Choose a size/option</label><select class="rp-input rp-variant-select">';
      variants.forEach(function(v, i){ html += '<option value="' + i + '">' + escapeHtml(v.title) + ' &mdash; ' + (v.price/100).toFixed(2) + '</option>'; });
      html += '</select><button type="button" class="rp-btn rp-select-variant">Select</button>';
      resultsBox.innerHTML = html;
      resultsBox.querySelector('.rp-select-variant').addEventListener('click', function(){ var idx = parseInt(resultsBox.querySelector('.rp-variant-select').value, 10); selectExchangeVariant(fli, product, variants[idx]); });
    }).catch(function(){ resultsBox.innerHTML = '<div class="rp-searching">Could not load that product. Please try another.</div>'; });
  }

  function selectExchangeVariant(fli, product, variant) {
    state.selections[fli].exchangeVariant = { id: 'gid://shopify/ProductVariant/' + variant.id, productTitle: product.title, title: variant.title, price: (variant.price / 100).toFixed(2), image: variant.featured_image ? variant.featured_image.src : (product.featured_image || null) };
    renderOrder();
  }

  function renderQuestions() {
    var a = state.answers;
    function yn(name, val) {
      return '<div class="rp-radio-group"><label class="rp-radio' + (val === true ? ' rp-radio-active' : '') + '"><input type="radio" name="' + name + '" value="yes" ' + (val === true ? 'checked' : '') + ' /> Yes</label><label class="rp-radio' + (val === false ? ' rp-radio-active' : '') + '"><input type="radio" name="' + name + '" value="no" ' + (val === false ? 'checked' : '') + ' /> No</label></div>';
    }
    var html = '<div class="rp-card"><h2 class="rp-h2">A few quick questions</h2><p class="rp-p">Please answer honestly &mdash; this helps us process your request as quickly as possible.</p>';
    html += '<div class="rp-question"><label class="rp-label">Is the tag and label still attached?</label>' + yn('q-tag', a.tag) + '</div>';
    html += '<div class="rp-question"><label class="rp-label">Is the item in its original packaging?</label>' + yn('q-packaging', a.packaging) + '</div>';
    html += '<div class="rp-question"><label class="rp-label">Has the item been worn or used?</label>' + yn('q-used', a.used) + '</div>';
    html += '<p class="rp-note">There is strictly no refunds or exchanges on items that do not meet our return conditions.</p>';
    var ready = a.tag !== null && a.packaging !== null && a.used !== null;
    html += '<button type="button" class="rp-btn" id="rp-submit" ' + (ready ? '' : 'disabled') + '>' + (state.submitting ? 'Submitting...' : 'Submit request') + '</button>';
    html += '<button type="button" class="rp-btn rp-btn-secondary" id="rp-back">Back</button></div>';
    root.innerHTML = html;
    Array.prototype.forEach.call(root.querySelectorAll('input[type=radio]'), function(rb){ rb.addEventListener('change', function(){ var val = this.value === 'yes'; if (this.name === 'q-tag') a.tag = val; if (this.name === 'q-packaging') a.packaging = val; if (this.name === 'q-used') a.used = val; renderQuestions(); }); });
    document.getElementById('rp-back').addEventListener('click', function(){ state.step = 'order'; render(); });
    var submitBtn = document.getElementById('rp-submit'); if (submitBtn) submitBtn.addEventListener('click', submitRequest);
  }

  function submitRequest() {
    state.submitting = true; renderQuestions();
    var items = [];
    Object.keys(state.selections).forEach(function(fli){ var s = state.selections[fli]; if (!s.checked) return; var entry = { fulfillmentLineItemId: fli, quantity: s.item.quantity }; if (s.action === 'exchange' && s.exchangeVariant) entry.exchangeVariantId = s.exchangeVariant.id; items.push(entry); });
    var action = items.some(function(i){ return !!i.exchangeVariantId; }) ? 'exchange' : 'return';
    fetch(WORKER_URL + '/api/submit', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ orderId: state.order.id, email: state.email, action: action, items: items, answers: { tagAttached: state.answers.tag, originalPackaging: state.answers.packaging, used: state.answers.used } }) })
      .then(function(r){ return r.json(); }).then(function(data){ state.submitting = false; state.result = data; state.step = 'result'; render(); })
      .catch(function(){ state.submitting = false; state.result = { ok: false }; state.step = 'result'; render(); });
  }

  function renderResult() {
    var r = state.result;
    var html = '<div class="rp-card">';
    if (r && r.ok && r.approved) {
      html += '<h2 class="rp-h2">Request approved</h2>';
      html += '<p class="rp-p">Your request' + (r.returnName ? ' (' + escapeHtml(r.returnName) + ')' : '') + ' has been approved. You will receive an email shortly with instructions on how to send your item(s) back to us.</p>';
      if (r.paymentUrl) {
        html += '<p class="rp-p">Because your new item costs more, there is a balance of ' + fmtMoney(r.priceDifference, r.currency) + ' to pay. We have also emailed you a secure payment link.</p>';
        html += '<a class="rp-btn" style="text-decoration:none;" href="' + escapeHtml(r.paymentUrl) + '" target="_blank" rel="noopener">Pay ' + fmtMoney(r.priceDifference, r.currency) + '</a>';
      } else if (typeof r.priceDifference === 'number' && r.priceDifference < -0.005) {
        html += '<p class="rp-note">Your new item costs ' + fmtMoney(Math.abs(r.priceDifference), r.currency) + ' less — we will be in touch about a partial refund.</p>';
      }
    } else if (r && r.ok && r.approved === false) {
      html += '<h2 class="rp-h2">We can&#39;t approve this request</h2><p class="rp-alert">' + escapeHtml(r.reason || 'This item does not meet our return conditions.') + '</p>';
    } else {
      html += '<h2 class="rp-h2">Something went wrong</h2><p class="rp-alert">We could not process your request. Please try again or contact us for help.</p>';
    }
    html += '<button type="button" class="rp-btn rp-btn-secondary" id="rp-restart">Start over</button></div>';
    root.innerHTML = html;
    document.getElementById('rp-restart').addEventListener('click', function(){ state.step = 'lookup'; state.order = null; state.selections = {}; state.answers = { tag: null, packaging: null, used: null }; state.result = null; render(); });
  }

  render()
})();
